/* @flow */

import _ from 'lodash';

export const getActivityByChild = (state: Object, child: Object) => (_.get(state.activity, [child.id], []));
